webpackJsonp([113],{

/***/ "5DhB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _events = __webpack_require__("vzCy");

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_LISTENERS = 100;
!function (root, factory) {
    root = root || {};
    if (!root.eventLib) {
        root.eventLib = factory();
    }
    if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
        module.exports = root.eventLib;
    }
    root.eventLib.setMaxListeners(MAX_LISTENERS);
}(typeof window !== 'undefined' ? window : undefined, function () {
    return new _events2.default.EventEmitter();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "D3Sj":
/***/ (function(module, exports) {

/**
 * @author Jensen<zhhnch@gmail.com>
 * @description 外部配置
 * @since 2018/4/8
 */
module.exports = {
    test: true,
    myUrl: "",
    pc_domain: "https://dev.ukelink.net/",
    threeDSecureBtn: true,
    api_domain: "http://m.glocalme.com:3001",
    rent_url:"https://enroamingman.ukelink.net/cooperation/?simple"
};


/***/ }),

/***/ "QmSG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _appConfig = __webpack_require__("D3Sj");

var _appConfig2 = _interopRequireDefault(_appConfig);

var _eventLib = __webpack_require__("5DhB");

var _eventLib2 = _interopRequireDefault(_eventLib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

setTimeout(function () {
    _eventLib2.default.emit('initAppConfig', _appConfig2.default);
});

/***/ })

},["QmSG"]);


// WEBPACK FOOTER //
// static/js/config_1.1.05.9_5bbfd1f92bc6381b3374.js